import ModifyWorkspace from './ModifyWorkspace';
export default ModifyWorkspace;
